import { useCallback } from 'react';
import useSearchType from '@awyes/cms/hooks/useSearchType';
import { fullProjection, resolverField } from '../../graphql/awyes/query/searchProductTypePage';

export const enums = {
  "searchBy": {
    "DEFAULT": "NAME_ID",
    "NAME_ID": "NAME_ID"
  },
  "orderBy": {
    "ASCENDING": "ASCENDING",
    "DESCENDING": "DESCENDING"
  }
};

const useSearchProductTypePage = (projection = fullProjection) => {
  const [state, { request }] = useSearchType({ projection, typeName: 'ProductTypePage', resolverField });
  const requestWithVars = useCallback(async function doRequest({ filter: { primary, sort } = {}, searchBy, orderBy, offset, limit }) {
    doRequest.aborted = false;
    await request({ filter: { primary, sort: (sort ? { [searchBy ?? enums.searchBy.DEFAULT]: sort } : undefined) }, searchBy, orderBy, offset, limit }, () => doRequest.aborted);
  }, [request]);
  return [state, { request: requestWithVars }];
};

export default useSearchProductTypePage;
